module.exports = __webpack_public_path__ + "static/media/cesped_decorativo.110c3fc4.jpg";